import type { DiagramType } from '../../../core/tools/interfaces/ITool';

const MANIFEST_FIRST_DIAGRAM_TYPES: ReadonlySet<DiagramType> = new Set<DiagramType>([
  'network' as DiagramType,
]);

const SHARED_CANVAS_NODE_TYPES: ReadonlySet<string> = new Set([
  'basic-shape',
  'flowchart-shape',
  'bpmn-shape',
  'org-shape',
  'frame',
  'freehand',
  'image',
  'pdf',
  'sticky-note',
  'table',
  'text',
]);

export function shouldRenderManifestFirst(diagramType: DiagramType | undefined, nodeType: string): boolean {
  return Boolean(
    diagramType &&
      MANIFEST_FIRST_DIAGRAM_TYPES.has(diagramType) &&
      !SHARED_CANVAS_NODE_TYPES.has(nodeType),
  );
}

export function isManifestFirstDiagramType(diagramType: DiagramType | undefined): diagramType is DiagramType {
  return Boolean(diagramType && MANIFEST_FIRST_DIAGRAM_TYPES.has(diagramType));
}
